import { FALLBACK_TIMEZONES } from "./constants";

export function slugifyOrganizationName(name) {
  if (!name || typeof name !== "string") return "";
  return name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-")
    .slice(0, 80);
}

export function buildTimezoneSelectOptions() {
  try {
    if (typeof Intl !== "undefined" && typeof Intl.supportedValuesOf === "function") {
      return Intl.supportedValuesOf("timeZone").map((z) => ({ value: z, label: z }));
    }
  } catch {
    /* ignore */
  }
  return FALLBACK_TIMEZONES.map((z) => ({ value: z, label: z }));
}

export function userRoleBadgeClass(role) {
  const r = String(role || "").toLowerCase();
  if (r === "medical_partner") return "success";
  if (r === "admin") return "primary";
  if (r === "manager") return "info";
  return "warning";
}

/** Platform catalog listing status for admin read-only display (MedicalPartnerDetails). */
export function practitionerListingBadge(decision) {
  const d = String(decision || "pending").toLowerCase();
  if (d === "approved") return { label: "Approved", className: "badge-dim bg-success" };
  if (d === "rejected") return { label: "Rejected", className: "badge-dim bg-danger" };
  return { label: "Pending", className: "badge-dim bg-warning" };
}
